module.exports = __webpack_public_path__ + "media/images/youtube-icon-cb83086ebb04ffb2a12a7d78fdb21161.png";